import OnBoarding from "./OnBoarding";
export default OnBoarding;